import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withTranslation } from 'react-i18next';
import { Grid } from '@material-ui/core';
import clsx from 'clsx';

// CONSTANTS
import { LOCATIONS_APP_PAGE } from '@/constants/locations';

// COMPONENTS
import Tabs from '@/components/Tabs';
import MultiselectSearch from '@/components/Form/MultiselectSearch';
import Zipcode from '@/components/Zipcode';

// STORE
import { AppDetailsSelectors } from '@/store/selectors';

// STYLES
import { FilterWrapper } from './styles';

class Filter extends PureComponent {
  state = {
    packages: [],
    addons: {},
  };

  componentDidMount() {
    this.initState();
  }

  initState = () => {
    const { allIds } = this.props;
    const packagesData = [];
    const addonsData = {};

    Object.keys(allIds).map(key => {
      if (!allIds[key].name) {
        return;
      }

      const packageData = {
        name: allIds[key].name,
        id: key,
        subname: allIds[key].cost ? `$${allIds[key].cost}` : '',
      };

      const addons = allIds[key].addons;
      if (allIds[key].addons) {
        const addonsKeys = Object.keys(addons);

        if (addonsKeys.length) {
          addonsData[key] = [];
          Object.keys(addons).map(addonKey => {
            const addonData = { id: addonKey, name: addons[addonKey] };

            return addonsData[key].push(addonData);
          });
        }
      }

      return packagesData.push(packageData);
    });

    this.setState({ packages: packagesData, addons: addonsData });
  };

  handleChangeTab = (name, value) => {
    const { setFilters } = this.props;

    const newFilters = {
      package: value,
      addons: [],
    };

    setFilters(newFilters);
  };

  handleChangeAddons = (name, value) => {
    const { setFilters, filters } = this.props;

    const newFilters = {
      ...filters,
      addons: value,
    };

    setFilters(newFilters);
  };

  handleChange = ({ target: { name, value } }) => {
    this.setState({ [name]: value });
  };

  render() {
    const { packages, addons } = this.state;
    const { t, allow_filter, filters, allIds, handleZipcodeSumbit } = this.props;

    const showTabs = Object.keys(allIds).length > 1;
    const showAddons = !!addons[filters.package]?.length;

    if (!showTabs && !showAddons && !allow_filter) {
      return null;
    }

    return (
      <FilterWrapper className="filter">
        <Grid container spacing={4}>
          {Object.keys(allIds).length > 1 && (
            <Grid item xs={12}>
              <Tabs
                className="filter__tabs m-t-25"
                value={filters.package || packages[0]?.id}
                options={packages}
                onChange={this.handleChangeTab}
              />
            </Grid>
          )}
          {(showAddons || allow_filter) && (
            <Grid item xs={12}>
              <div className={clsx(!showTabs && 'm-t-25')}>
                <Grid container spacing={4} justifyContent="center" alignItems="flex-end">
                  {showAddons && (
                    <Grid item xs={12} md={allow_filter ? 6 : 8} lg={8}>
                      <MultiselectSearch
                        className="filter__search"
                        data={addons[filters.package]}
                        selected={filters.addons}
                        placeholder={t('inputs.selectAddons')}
                        onChange={this.handleChangeAddons}
                        showChevron
                        InputProps={{
                          endAdornment: !!filters.addons.length && (
                            <div className="filter__count-available">
                              {t('common.countAvailable', { count: filters.addons.length })}
                            </div>
                          ),
                        }}
                      />
                    </Grid>
                  )}
                  {allow_filter && (
                    <Grid item xs={12} md={showAddons ? 6 : 8} lg={showAddons ? 4 : 8}>
                      <Zipcode
                        className="filter__zipcode"
                        onSubmit={handleZipcodeSumbit}
                        analyticsLocation={LOCATIONS_APP_PAGE}
                      />
                    </Grid>
                  )}
                </Grid>
              </div>
            </Grid>
          )}
        </Grid>
      </FilterWrapper>
    );
  }
}

Filter.propTypes = {
  t: PropTypes.func.isRequired,
  allow_filter: PropTypes.bool.isRequired,
  allIds: PropTypes.object,
  setFilters: PropTypes.func,
  filters: PropTypes.object,
  handleZipcodeSumbit: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  allow_filter: AppDetailsSelectors.getChannelsAllowFilter(state),
});

export default compose(withTranslation(), connect(mapStateToProps))(Filter);
